// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pqVaFOty8rdwIQ91X6a3 {
  height: 100%;
  margin-bottom: 15px;
}

.GRdSpfd88_dpIZSuWiel {
  padding: 8px;
  border-radius: 12px;
  background: rgba(var(--secondary-bg), 0.40);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  border-radius: 12px;
  margin-bottom: 10px;
  > img {
    object-fit: contain;
    border-radius: 12px;
    margin-bottom: 8px;
  }
}

.IW_8o5i8C8hcQHkAKmIi {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 20px;
  font-weight: 540;
  margin-bottom: 8px;
  padding: 16px;
  background: rgb(var(--border-dark), 0.40);
  border-radius: 28px;
  color: rgb(var(--placeholder-primary));
}

.iTFR7xVAl7bQ84MDpA3h {
  font-size: 14px;
  color: #8e8e93;
  margin-bottom: 10px;
}

.YdAUtzC0YWw5S1OjFHFt {
  position: relative;
}

.ceQjKp1W3sNMy_lI2n5Q {
  padding-top: 10px;
  color: #8e8e93;
  font-size: 16px;
  margin-bottom: 10px;
}

.YdAUtzC0YWw5S1OjFHFt:after {
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(116, 116, 128, 0.4);
}

.xiUGYCpXeo9KYuYZxl_m {
  padding: 16px;
  background: rgba(var(--secondary-bg), 0.40);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  border-radius: 20px;
  margin-top: 16px;
}

.NFw5sZcmubbHRGChXBsY {
  color: rgb(var(--placeholder-tertiary));
}

.yBbVCYYprHBOaa5lN81o {
  width: 100%;
  margin: 10px 0;
  padding: 10px !important;
  height: 45px;
  font-size: 18px;
}

.wd2yrZ0qZ8iE98AhxmCo {
  border-radius: 12px;
}

.KqnxGY5DH2b1IvpzY2MM {
  font-size: 16px;
  margin-bottom: 16px;
  color: rgb(var(--placeholder-primary));
}

.R3QKMnerHvkArKPCWAWy {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  padding-bottom: 17px;
}

.R3QKMnerHvkArKPCWAWy:after {
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: 0;
  right: 0;
  border-bottom: 1px dashed rgba(116, 116, 128, 0.4);
}

.G8R8tjSgWbbb715l1Tdg {
  font-size: 16px;
  cursor: pointer;
  transition: text-decoration 0.3s ease 0s;
}

.G8R8tjSgWbbb715l1Tdg:hover {
  text-decoration: underline;
}

.rJ0kXlPduzx0XvPsdhGZ {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 15px 0;
  color: #1c77ff;
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  border: none;
  transition: color 0.3s ease 0s;
}

.rJ0kXlPduzx0XvPsdhGZ:hover {
  color: #055ada !important;
  background: transparent;
}

/*--------------------alert--------------------*/

.dFN0jOhUZXyLKR4TidpI {
  color: #fff;
  background: rgb(var(--accent-brand));
  border: 0;
  border-radius: 10px 0 0 10px;
}

.dFN0jOhUZXyLKR4TidpI > button {
  color: #fff !important;
}
  
/*--------------------/alert--------------------*/`, "",{"version":3,"sources":["webpack://./src/pages/nft-detail/nft-detail.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,gDAAgD;;AAEhD;EACE,WAAW;EACX,oCAAoC;EACpC,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD","sourcesContent":[".nft {\n  height: 100%;\n  margin-bottom: 15px;\n}\n\n.nftTop {\n  padding: 8px;\n  border-radius: 12px;\n  background: rgba(var(--secondary-bg), 0.40);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  border-radius: 12px;\n  margin-bottom: 10px;\n  > img {\n    object-fit: contain;\n    border-radius: 12px;\n    margin-bottom: 8px;\n  }\n}\n\n.nftTitle {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 20px;\n  font-weight: 540;\n  margin-bottom: 8px;\n  padding: 16px;\n  background: rgb(var(--border-dark), 0.40);\n  border-radius: 28px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.nftCollection {\n  font-size: 14px;\n  color: #8e8e93;\n  margin-bottom: 10px;\n}\n\n.nftInfo {\n  position: relative;\n}\n\n.nftDetail {\n  padding-top: 10px;\n  color: #8e8e93;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.nftInfo:after {\n  content: '';\n  width: 100%;\n  height: 1px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: rgba(116, 116, 128, 0.4);\n}\n\n.nftBottom {\n  padding: 16px;\n  background: rgba(var(--secondary-bg), 0.40);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  border-radius: 20px;\n  margin-top: 16px;\n}\n\n.nftBottomLeft {\n  color: rgb(var(--placeholder-tertiary));\n}\n\n.nftSendBtn {\n  width: 100%;\n  margin: 10px 0;\n  padding: 10px !important;\n  height: 45px;\n  font-size: 18px;\n}\n\n.nftBottomInner {\n  border-radius: 12px;\n}\n\n.nftBottomTitle {\n  font-size: 16px;\n  margin-bottom: 16px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.nftBottomItem {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5px;\n  padding-bottom: 17px;\n}\n\n.nftBottomItem:after {\n  content: '';\n  width: 100%;\n  height: 1px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  border-bottom: 1px dashed rgba(116, 116, 128, 0.4);\n}\n\n.nftBottomRight {\n  font-size: 16px;\n  cursor: pointer;\n  transition: text-decoration 0.3s ease 0s;\n}\n\n.nftBottomRight:hover {\n  text-decoration: underline;\n}\n\n.modalTopButton {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin: 15px 0;\n  color: #1c77ff;\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  transition: color 0.3s ease 0s;\n}\n\n.modalTopButton:hover {\n  color: #055ada !important;\n  background: transparent;\n}\n\n/*--------------------alert--------------------*/\n\n.alert {\n  color: #fff;\n  background: rgb(var(--accent-brand));\n  border: 0;\n  border-radius: 10px 0 0 10px;\n}\n\n.alert > button {\n  color: #fff !important;\n}\n  \n/*--------------------/alert--------------------*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nft": `pqVaFOty8rdwIQ91X6a3`,
	"nftTop": `GRdSpfd88_dpIZSuWiel`,
	"nftTitle": `IW_8o5i8C8hcQHkAKmIi`,
	"nftCollection": `iTFR7xVAl7bQ84MDpA3h`,
	"nftInfo": `YdAUtzC0YWw5S1OjFHFt`,
	"nftDetail": `ceQjKp1W3sNMy_lI2n5Q`,
	"nftBottom": `xiUGYCpXeo9KYuYZxl_m`,
	"nftBottomLeft": `NFw5sZcmubbHRGChXBsY`,
	"nftSendBtn": `yBbVCYYprHBOaa5lN81o`,
	"nftBottomInner": `wd2yrZ0qZ8iE98AhxmCo`,
	"nftBottomTitle": `KqnxGY5DH2b1IvpzY2MM`,
	"nftBottomItem": `R3QKMnerHvkArKPCWAWy`,
	"nftBottomRight": `G8R8tjSgWbbb715l1Tdg`,
	"modalTopButton": `rJ0kXlPduzx0XvPsdhGZ`,
	"alert": `dFN0jOhUZXyLKR4TidpI`
};
export default ___CSS_LOADER_EXPORT___;
